import React, { useState, useEffect } from 'react';
import './App.css';
import RegistrationForm from './components/Registration/RegistrationForm';
import VisitorsList from './components/CurrentVisitors/VisitorsList';
import HistoryList from './components/History/HistoryList';
import PinLogin from './components/Auth/PinLogin';
import Tjanstevillkor from './components/Legal/Tjanstevillkor';
import Integritetspolicy from './components/Legal/Integritetspolicy';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { getFeatureFlags } from './services/api';

function AppContent() {
  const initialPage = window.location.pathname === '/tjanstevillkor' ? 'tjanstevillkor'
    : window.location.pathname === '/integritetspolicy' ? 'integritetspolicy' : 'current';
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [features, setFeatures] = useState({});
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      getFeatureFlags().then(setFeatures).catch(() => {});
    }
  }, [isAuthenticated]);

  const renderPage = () => {
    switch (currentPage) {
      case 'registration':
        return <RegistrationForm onSuccess={() => setCurrentPage('current')} features={features} />;
      case 'current':
        return <VisitorsList features={features} />;
      case 'history':
        return <HistoryList features={features} />;
      case 'tjanstevillkor':
        return <Tjanstevillkor />;
      case 'integritetspolicy':
        return <Integritetspolicy />;
      default:
        return <VisitorsList />;
    }
  };

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
          Laddar...
        </div>
      </div>
    );
  }

  // Show PIN login if not authenticated
  if (!isAuthenticated) {
    return <PinLogin />;
  }

  // Show main app if authenticated
  return (
    <div className="App">
      <header className="App-header">
        <img
          src="/assets/images/lantmannen-logo.png"
          alt="Lantmännen Besöksregistrering"
          className="App-logo"
        />
        <nav className="App-nav">
          <button
            className={currentPage === 'registration' ? 'active' : ''}
            onClick={() => setCurrentPage('registration')}
          >
            Registrera
          </button>
          <button
            className={currentPage === 'current' ? 'active' : ''}
            onClick={() => setCurrentPage('current')}
          >
            Gäster
          </button>
          <button
            className={currentPage === 'history' ? 'active' : ''}
            onClick={() => setCurrentPage('history')}
          >
            Historik
          </button>
        </nav>
      </header>
      <main className="App-main">
        {renderPage()}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;